module.exports = __webpack_public_path__ + "static/media/online_one_to_one.df10dfe4.png";